<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 14 }"
    :visible="open"
    @close="onCloseConfirm(() => (open = false))"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="编码" prop="code">
        <a-input v-model="form.code" placeholder="请输入" :maxLength="50" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="话术名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入" :maxLength="50" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1">启用</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="话术说明" prop="referenceExplanation">
        <a-input v-model="form.referenceExplanation" placeholder="请输入" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="价格参考" prop="referencePrice">
        <a-input
          v-model="form.referencePrice"
          placeholder="请输入"
          allow-clear
          @input="form.referencePrice = form.referencePrice.replace(/\D/g, '')"
        />
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入" :maxLength="150" :rows="3" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input
          v-model="form.sort"
          placeholder="请输入"
          :maxLength="3"
          allow-clear
          @input="form.sort = form.sort.replace(/\D/g, '').slice(0, 3)"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getObj, addObj, putObj } from '@/api/maintenance/repairprice/index.js'

const defaultForm = {
  id: undefined,
  parentId: 0,
  grade: 1,
  code: undefined,
  name: undefined,
  referenceExplanation: undefined,
  referencePrice: undefined,
  status: 1,
  sort: 99,
  remark: undefined,
}

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      submitLoading: false,
      open: false,
      showLoading: false,
      formTitle: '',
      form: { ...defaultForm },
      rules: {
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入话术名称', trigger: 'blur' }],
        referenceExplanation: [{ required: true, message: '请输入话术说明', trigger: 'blur' }],
        referencePrice: [{ required: true, message: '请输入价格参考', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
    }
  },
  methods: {
    handleAdd(parentRow, forceGrade) {
      this.reset()
      if (parentRow) {
        // 强制指定层级 > 推导层级
        const grade = forceGrade || (parentRow.grade || 1) + 1
        if (grade > 3) {
          this.$message.warning('最多支持三级维修价格参考')
          return
        }
        this.form.parentId = parentRow.id
        this.formTitle = grade === 2 ? '添加二级维修价格参考' : '添加三级维修价格参考'
      } else {
        this.form.parentId = 0
        this.formTitle = '添加一级维修价格参考'
      }
      this.open = true
    },
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      getObj(id).then((res) => {
        this.form = res.data
        this.formTitle = '修改话术'
        this.open = true
      })
    },
    reset() {
      this.form = { ...defaultForm }
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    cancel() {
      this.onCloseConfirm(() => (this.open = false))
    },
    onCloseConfirm(done) {
      this.$confirm({
        title: '是否确认关闭并清空数据？',
        onOk: () => {
          this.reset()
          done()
        },
      })
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        this.showLoading = true
        this.$nextTick(() => this.$refs.LoadingPop.init(1))

        const api = this.form.id ? putObj : addObj
        api(this.form)
          .then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功')
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
            this.showLoading = false
          })
      })
    },
  },
}
</script>
